// components/AuthLayout.jsx
export const AuthLayout = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-[var(--app-height,100dvh)] overflow-y-auto overscroll-contain bg-[#F3F0FF] flex items-start sm:items-center justify-center px-4 py-6 sm:py-8">
      <div className="w-full max-w-[520px] p-6 sm:p-8 md:p-10">
        {/* Logo + Title */}  
        {title && (
          <div className="space-y-3 mb-6">
            <div className="text-xl text-[#000000] font-medium text-center">
              {title}
            </div>
            {subtitle && (
              <p className="text-[#475467] font-medium text-center">
                {subtitle}
              </p>
            )}
          </div>
        )}

        {children}
      </div>
    </div>
  );
};